<div [hidden]="!showList">
  <main class="container-lg my-3">
    <header class="d-flex justify-content-between">
      <h1>Mis <span>Casos</span></h1>
      <button mat-button class="button secondary-button" (click)="onCreateNewCase()" *ngIf="dataSource?.data.length!=0">Crear nuevo caso <mat-icon>add</mat-icon></button>
    </header>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <p class="text-muted">Filtros:</p>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 gy-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Id/Código</mat-label>
            <input matInput type="text" name="searchById" [(ngModel)]="searchValueById" />
            <button mat-button *ngIf="searchValueById" matSuffix mat-icon-button aria-label="Clear" (click)="searchValueById=''; refreshList()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-lg-3 gy-4">
          <mat-form-field appearance="outline" class="w-100">
            <mat-icon matPrefix>search</mat-icon>
            <mat-label>Paciente/Email de Paciente</mat-label>
            <input matInput type="text" name="searchByPatient" [(ngModel)]="searchByPatient" />
            <button mat-button *ngIf="searchByPatient" matSuffix mat-icon-button aria-label="Clear" (click)="searchByPatient=''; refreshList()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-lg-3 gy-4">
          <mat-form-field class="w-100" appearance="outline">
            <mat-label>Tipo de estatus</mat-label>
            <mat-select matInput name="searchByStatusType" [(ngModel)]="searchByStatusType">
              <mat-option *ngFor="let item of statusOptions" value="{{item.value}}">{{item.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6 col-lg-3 gy-4">
          <button mat-button class="button primary-button lh-1 p-3 w-100" (click)="onGetFilteredResults()">Obtener Resultados</button>
        </div>
      </div>
    </div>

    <section *ngIf="!showCrud">
      <div [hidden]="dataSource?.data.length==0 && isLoading">
        <mat-table #table [dataSource]="dataSource" matSort class="mobile-table" (matSortChange)="onSortChange($event)">
          <!-- Responsive Table -->
          <ng-container [matColumnDef]="column.display" *ngFor="let column of displayedColumns">
              <mat-header-cell *matHeaderCellDef mat-sort-header="{{column.property}}" [disabled]="column.display=='Acciones'"> {{column.display}} </mat-header-cell>
              <mat-cell *matCellDef="let element" class="row p-0 m-0">
                  <span class="col-12 mobile-label"> {{column.display}}:</span>
                  <span class="col-12" style="border-radius: 5px;" *ngIf="column.display != 'Acciones' && column.display != 'Código' && column.display != 'Alineadores comprados' && column.display !='Producto'; else actionsTemplate"
                    [ngClass]="{'bg-warning': element['isPartialSave'] && column.display == 'Estatus'}"
                    [ngStyle]="{'background-color': getBackgroundColor(column.display, element), 'color': getColor(column.display, element) }"
                  >
                  {{ column.property == "statusDescriptionEcommerce" && element['isPartialSave'] ? 'Caso incompleto' : element[column.property] | dynamic:column.pipe}}
                  </span>
                  <span  *ngIf="column.property == 'code' && column.display != 'Acciones' && column.display != 'Alineadores comprados' && column.display !='Producto'">
                    <div *ngIf="element['isPartialSave'] || element['statusId']==18;else completeCaseCodeTemplate">
                      {{  element[column.property] | dynamic:column.pipe}}
                    </div>
                    <ng-template #completeCaseCodeTemplate>
                      <a href="/ecommerce/mis-casos/detail/{{element.id}}">
                        {{  element[column.property] | dynamic:column.pipe}}
                      </a>
                    </ng-template>
                    
                  </span>
                  <ng-template #actionsTemplate>
                    <ng-container *ngIf="column.display === 'Producto'">
                      <span *ngIf="element[column.property]!=''; else noProductTemplate">{{element[column.property] | dynamic:column.pipe}}</span>
                      <ng-template #noProductTemplate>
                        <span><mat-icon class="material-icons-outlined" style="color: red !important; font-size: 16px !important; width:16px; height:16px !important;">
                          priority_high
                          </mat-icon> <span class="ms-1">Producto o pago pendiente</span></span>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="column.display == 'Acciones'">
                      <div *ngIf="!element['isPartialSave'] && element['statusId'] !=18;else completeTemplate">
                        <a href="/ecommerce/mis-casos/detail/{{element.id}}">
                          <button class="button secondary-button desktop-action-button" [ngClass]="{'bg-warning': element['isPartialSave']}" style="padding: 5px 10px!important; width: fit-content; height: fit-content;">{{element['isPartialSave'] ? 'Completar' : 'Detalles'}}</button>
                        </a>

                        <a href = "/ecommerce/mis-casos/detail/{{element.id}}">
                          <button class="button secondary-button mobile-action-button" [matTooltip]="element['isPartialSave'] ? 'Completar' : 'Detalles'" [ngClass]="{'bg-warning': element['isPartialSave']}" style="padding: 5px 10px!important; width: fit-content; height: fit-content;" (click)="onSelect(element)"><mat-icon>{{element['isPartialSave'] ? 'edit' : 'expand_more'}}</mat-icon></button>
                        </a>
                      </div>

                      <div *ngIf="element['statusId'] !=18 && element['isPartialSave'];else rejectedFilesTemplate ">
                        <button class="button secondary-button desktop-action-button" [ngClass]="{'bg-warning': element['isPartialSave']}" style="padding: 5px 10px!important; width: fit-content; height: fit-content;" (click)="onSelect(element)">Completar</button>
                        <button class="button secondary-button mobile-action-button" [matTooltip]="element['isPartialSave'] ? 'Completar' : 'Detalles'" [ngClass]="{'bg-warning': element['isPartialSave']}" style="padding: 5px 10px!important; width: fit-content; height: fit-content;" (click)="onSelect(element)"><mat-icon>{{'edit'}}</mat-icon></button>
                      </div>

                      
                      <div #rejectedFilesTemplate  *ngIf="element['statusId'] ==18">
                        <button class="button secondary-button desktop-action-button" [ngClass]="{'bg-warning': element['statusId'] ==18}" style="padding: 5px 10px!important; width: fit-content; height: fit-content;" (click)="onGoToFileCorrection(element)">Subir archivos</button>
                        <button class="button secondary-button mobile-action-button" [matTooltip]="element['isPartialSave'] ? 'Completar' : 'Subir Archivos'" [ngClass]="{'bg-warning': element['isPartialSave']}" style="padding: 5px 10px!important; width: fit-content; height: fit-content;" (click)="onGoToFileCorrection(element)"><mat-icon>{{'upload'}}</mat-icon></button>
                      </div>
                     
                    </ng-container>
                    <ng-container *ngIf="column.display == 'Alineadores comprados'">
                      <span *ngIf="element['productHasUnlimtedAligners']">---</span>
                      <span *ngIf="!element['productHasUnlimtedAligners']">{{element[column.property] | dynamic:column.pipe}}</span>
                    </ng-container>
                  </ng-template>
              </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="columnsToDisplay"></mat-header-row>
          <mat-row *matRowDef="let row; columns: columnsToDisplay;" ></mat-row>
        </mat-table>
        <mat-paginator #paginator [length]="totalRows"
                      [showFirstLastButtons]="true"
                      [pageSize]="10"
                      [pageSizeOptions]="[5, 10, 25, 100]"
                      (page)="getAll(true)">
        </mat-paginator>
      </div>

      <div *ngIf="isLoading">
        <app-loading></app-loading>
        <h1>Obteniendo recursos...</h1>
      </div>

      <div class="w-75 h-100 d-flex flex-column justify-content-center align-items-center gap-4 mx-auto" *ngIf="dataSource?.data.length==0 && !isLoading">
        <p>Aún no tienes ningún caso registrado, intenta creando uno nuevo</p>
        <button class="button secondary-button w-50" (click)="onCreateNewCase()">Crear nuevo caso</button>
      </div>

    </section>
  </main>
</div>
